.input-addon {
  display: inline-flex;
  align-items: center;
  padding: 0 11px;
  height: 32px;
  font-size: 14px;
  line-height: 30px;
  background-color: var(--ant-color-fill-tertiary);
  border: 1px solid var(--ant-color-border);
  border-radius: 6px;
  position: relative;
  z-index: 1;
  color: var(--ant-color-text);
  white-space: nowrap;
}

.ant-space-compact > .input-addon:not(:first-child) {
  margin-inline-start: -1px;
}

.ant-space-compact > .input-addon:first-child {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}

.ant-space-compact > .input-addon:last-child {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}

.ant-space-compact > .input-addon:not(:first-child):not(:last-child) {
  border-radius: 0;
}
